/** Federn aus Designsprache-Tokens 6 (Motion). Keine anderen Kurven verwenden. */

import type { Transition } from "motion/react";

const feder = (stiffness: number, damping: number): Transition => ({ type: "spring", stiffness, damping, mass: 1 });

export const FEDER = {
  sheetAuf: feder(220, 27),
  sheetZu: feder(300, 34),
  druecken: feder(600, 44),
  loslassen: feder(400, 30),
  segment: feder(400, 34),
} as const;

/** Ueberblendung bei reduzierter Bewegung (0,20 s). „Dokument oeffnen“ laeuft als View Transition in
 *  CSS (bausteine.css, Tokens --dur-dokument, --kurve-dokument); Listenaenderungen folgen mit den
 *  Wisch-Aktionen (B-041). */
export const UEBERBLENDUNG: Transition = { duration: 0.2, ease: [0.25, 0.1, 0.25, 1] };
